import { useEffect, useMemo } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Loader2Icon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { isIOS } from "@/lib/isIOS";
import { ANDROID_APP_URL, IOS_APP_URL } from "@/lib/storeLinks";

export const Route = createFileRoute("/download")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const storeUrl = useMemo(() => {
    if (isIOS()) return IOS_APP_URL;
    return ANDROID_APP_URL;
  }, []);

  useEffect(() => {
    window.location.replace(storeUrl);
  }, [storeUrl]);

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-4 text-center">
      <Loader2Icon className="size-8 animate-spin text-neutral-400" />
      <p className="text-sm text-neutral-400">
        {t("download_redirect_message")}
      </p>
      <a href={storeUrl} className="text-xs text-neutral-500 underline">
        {t("download_manual_link")}
      </a>
    </div>
  );
}
